import type { Locale } from '@webcatalog/constants/locales';

import { requireI18nContext } from '~marketing/utils/require-i18n-context';

export const getLocale = (): Locale => requireI18nContext().locale;
